module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-fabric straps-Ki-La.a7515a8d.png";